import { render, staticRenderFns } from "./MollieConnectRedirect.vue?vue&type=template&id=11057108&scoped=true"
import script from "./MollieConnectRedirect.vue?vue&type=script&lang=ts"
export * from "./MollieConnectRedirect.vue?vue&type=script&lang=ts"
import style0 from "./MollieConnectRedirect.vue?vue&type=style&index=0&id=11057108&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11057108",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11057108')) {
      api.createRecord('11057108', component.options)
    } else {
      api.reload('11057108', component.options)
    }
    module.hot.accept("./MollieConnectRedirect.vue?vue&type=template&id=11057108&scoped=true", function () {
      api.rerender('11057108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/MollieConnectRedirect.vue"
export default component.exports